export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-937140ca11f601b49ba52e6633e6f62f.svg";